import { StorageHandler } from './storage';
import { createContext, useContext } from 'react';
import { BarcodeScannerComponent, MediaPickerComponent, SignatureScreenComponent } from './media';
import { ILogger } from './logging';
import type { OutboxService } from './offline/outboxService';

/**
 * What shared code may ask of the device's offline cache. The store itself is
 * the app's (SQLite), which shared-logic cannot import, so the app supplies
 * this through the context; web provides nothing.
 */
export interface OfflineCacheService {
  /** Removes everything cached for the account. Unsynced work is not touched. */
  clear: (accountId: string) => Promise<void>;
}

export interface GrippContextData {
  storageHandler: StorageHandler;
  secureStorageHandler: StorageHandler;
  mediaPickerComponent?: MediaPickerComponent;
  signaturePadScreen?: SignatureScreenComponent;
  barcodeScannerComponent?: BarcodeScannerComponent;
  logger: ILogger;
  offlineCache?: OfflineCacheService;
  /** The device's outbox; web provides nothing and shared code then acts directly. */
  outbox?: OutboxService;
}

export const GrippContext = createContext<GrippContextData | undefined>(
  undefined
);

export const useGrippContext = (): GrippContextData => {
  return useContext(GrippContext)!;
};
